module.exports = __webpack_public_path__ + "img/Comic07-3.b16e3d0a.png";